export default "__VITE_ASSET__iJzzyjyl__"